module.exports = __webpack_public_path__ + "static/media/wall13.b31aa013.jpeg";